import React from 'react';
import i18n from 'i18next';
import CommercialProjectToggle from '../costFragments/CommercialProjectToggle';
const renderCommercialProjectToggle = _ref => {
  let {
    row: costFragment,
    column,
    tabIndex
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(CommercialProjectToggle, {
    costFragment: costFragment,
    onToggleExpand: () => column.toggleRowExpansion?.(costFragment),
    isExpanded: costFragment['row_expanded']
  }));
};
const headers = {
  consolidated: {
    regular: claim => [{
      text: '',
      cellType: 'CommercialProjectToggle',
      renderCell: renderCommercialProjectToggle
    }, {
      text: 'Business Unit',
      cellType: 'BusinessUnitDropdown',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.business_unit?.name || '',
      valueFn: r => r.data.object.business_unit?.name || ''
    }, {
      text: 'Project Name',
      cellType: 'ProjectSelector',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.claim_project_report?.project_name || '',
      valueFn: r => r.data.object.claim_project_report?.project_name || ''
    }, {
      text: 'Project Type',
      fieldName: 'program_type',
      disabled: true,
      cellType: 'text',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.claim_project_report?.program_type || '',
      valueFn: r => i18n.t(r.data.object.claim_project_report?.program_type) || '',
      translateValue: true
    }, {
      text: 'SME/RDEC',
      fieldName: 'rate_type',
      disabled: true,
      cellType: 'text',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.rate_type || '',
      valueFn: r => i18n.t(r.data.object.rate_type) || '',
      translateValue: true
    }, {
      text: 'Methodology Item',
      fieldName: 'rate_type',
      cellType: 'text',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.claim_project_report.cost_methodology_type || '',
      disabled: true,
      valueFn: r => r.data.object.claim_project_report.cost_methodology_type || '',
      translateValue: true
    }, 'individual' === claim.claim_group.staffing_cost_aggregation_type ? {
      text: 'Employee Name',
      fieldName: 'name',
      cellType: 'text',
      model: 'fragmentable',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.fragmentable.name,
      valueFn: r => r.data.object.fragmentable?.name || ''
    } : null, ['individual', 'function'].includes(claim.claim_group.staffing_cost_aggregation_type) ? {
      text: 'Role/Title',
      fieldName: 'role',
      cellType: 'text',
      model: 'fragmentable',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.fragmentable.role,
      valueFn: r => r.data.object.fragmentable?.role || ''
    } : null, {
      text: 'Salary',
      fieldName: 'base_salary',
      cellType: 'number',
      model: 'fragmentable',
      valueFn: r => r.data.object.fragmentable?.base_salary ?? ''
    }, {
      text: 'Bonus',
      fieldName: 'bonus',
      cellType: 'number',
      model: 'fragmentable',
      valueFn: r => r.data.object.fragmentable?.bonus ?? ''
    }, {
      text: 'ER NI',
      fieldName: 'national_insurance',
      cellType: 'number',
      model: 'fragmentable',
      valueFn: r => r.data.object.fragmentable?.national_insurance ?? ''
    }, {
      text: 'Pension',
      fieldName: 'pension',
      cellType: 'number',
      model: 'fragmentable',
      valueFn: r => r.data.object.fragmentable?.pension ?? ''
    }, {
      text: 'Reimbursed',
      fieldName: 'reimbursed_expenses',
      cellType: 'number',
      model: 'fragmentable',
      valueFn: r => r.data.object.fragmentable?.reimbursed_expenses ?? ''
    }, {
      text: 'Total',
      fieldName: 'total',
      disabled: true,
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.total),
      valueFn: r => r.data.object.total ?? ''
    }, claim.is_staffing_cost_rate_reduction_required ? {
      text: 'Reduction Factor',
      fieldName: 'reduction_rate_percentage',
      disabled: true,
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.reduction_rate_percentage),
      valueFn: r => r.data.object.reduction_rate_percentage != null ? `${Number(r.data.object.reduction_rate_percentage).toFixed(1)}%` : ''
    } : null, claim.is_staffing_cost_rate_reduction_required ? {
      text: 'Eligible Total',
      fieldName: 'eligible_total_amount',
      disabled: true,
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.eligible_total_amount),
      valueFn: r => r.data.object.eligible_total_amount ?? ''
    } : null, {
      text: 'Capitalised Costs (if any)',
      fieldName: 'capitalised_costs',
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.capitalised_costs),
      valueFn: r => r.data.object.capitalised_costs ?? ''
    }, {
      text: 'Direct R&D%',
      fieldName: 'direct_rnd_percentage',
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.direct_rnd_percentage),
      valueFn: r => r.data.object.direct_rnd_percentage != null ? `${Number(r.data.object.direct_rnd_percentage).toFixed(1)}%` : ''
    }, {
      text: 'Indirect R&D%',
      fieldName: 'indirect_rnd_percentage',
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.indirect_rnd_percentage),
      valueFn: r => r.data.object.indirect_rnd_percentage != null ? `${Number(r.data.object.indirect_rnd_percentage).toFixed(1)}%` : ''
    }, {
      text: 'Consolidated % of Time Spent',
      fieldName: 'consolidated_percentage_of_time_spent',
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.consolidated_percentage_of_time_spent),
      valueFn: r => r.data.object.consolidated_percentage_of_time_spent != null ? `${Number(r.data.object.consolidated_percentage_of_time_spent).toFixed(1)}%` : ''
    }, {
      text: 'Eligible R&D %',
      fieldName: 'eligible_rnd_percentage',
      cellType: 'percentage',
      decimalScale: 1,
      disabled: true,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.eligible_rnd_percentage),
      valueFn: r => r.data.object.eligible_rnd_percentage != null ? `${Number(r.data.object.eligible_rnd_percentage).toFixed(1)}%` : ''
    }, {
      text: 'R&D Amount',
      fieldName: 'rnd_amount',
      disabled: true,
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.rnd_amount),
      valueFn: r => r.data.object.rnd_amount ?? ''
    }, {
      text: 'P&L R&D Expenditure',
      fieldName: 'pnl_expenditure',
      disabled: true,
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.pnl_expenditure),
      valueFn: r => r.data.object.pnl_expenditure ?? ''
    }, {
      text: 's1308 Claim',
      fieldName: 's1308_claim',
      disabled: true,
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.s1308_claim),
      valueFn: r => r.data.object.s1308_claim ?? ''
    }].filter(Boolean),
    realtime: claim => [{
      text: '',
      cellType: 'CommercialProjectToggle',
      renderCell: renderCommercialProjectToggle
    }, {
      text: 'Business Unit',
      cellType: 'BusinessUnitDropdown',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.business_unit?.name || '',
      valueFn: r => r.data.object.business_unit?.name || ''
    }, {
      text: 'Project Name',
      cellType: 'ProjectSelector',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.claim_project_report?.project_name || '',
      valueFn: r => r.data.object.claim_project_report?.project_name || ''
    }, {
      text: 'Project Type',
      fieldName: 'program_type',
      disabled: true,
      cellType: 'text',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.claim_project_report?.program_type || '',
      valueFn: r => i18n.t(r.data.object.claim_project_report?.program_type) || '',
      translateValue: true
    }, {
      text: 'SME/RDEC',
      fieldName: 'rate_type',
      disabled: true,
      cellType: 'text',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.rate_type || '',
      valueFn: r => i18n.t(r.data.object.rate_type) || '',
      translateValue: true
    }, {
      text: 'Methodology Item',
      fieldName: 'rate_type',
      cellType: 'text',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.claim_project_report.cost_methodology_type || '',
      disabled: true,
      valueFn: r => r.data.object.claim_project_report.cost_methodology_type || '',
      translateValue: true
    }, 'individual' === claim.claim_group.staffing_cost_aggregation_type ? {
      text: 'Employee Name',
      fieldName: 'name',
      cellType: 'text',
      model: 'fragmentable',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.fragmentable.name,
      valueFn: r => r.data.object.fragmentable?.name || ''
    } : null, ['individual', 'function'].includes(claim.claim_group.staffing_cost_aggregation_type) ? {
      text: 'Role/Title',
      fieldName: 'role',
      cellType: 'text',
      model: 'fragmentable',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.fragmentable.role,
      valueFn: r => r.data.object.fragmentable?.role || ''
    } : null, {
      text: 'Salary',
      fieldName: 'base_salary',
      cellType: 'number',
      model: 'fragmentable',
      valueFn: r => r.data.object.fragmentable?.base_salary ?? ''
    }, {
      text: 'Bonus',
      fieldName: 'bonus',
      cellType: 'number',
      model: 'fragmentable',
      valueFn: r => r.data.object.fragmentable?.bonus ?? ''
    }, {
      text: 'ER NI',
      fieldName: 'national_insurance',
      cellType: 'number',
      model: 'fragmentable',
      valueFn: r => r.data.object.fragmentable?.national_insurance ?? ''
    }, {
      text: 'Pension',
      fieldName: 'pension',
      cellType: 'number',
      model: 'fragmentable',
      valueFn: r => r.data.object.fragmentable?.pension ?? ''
    }, {
      text: 'Reimbursed',
      fieldName: 'reimbursed_expenses',
      cellType: 'number',
      model: 'fragmentable',
      valueFn: r => r.data.object.fragmentable?.reimbursed_expenses ?? ''
    }, {
      text: 'Total',
      fieldName: 'total',
      cellType: 'number',
      disabled: true,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.total),
      valueFn: r => r.data.object.total ?? ''
    }, claim.is_staffing_cost_rate_reduction_required ? {
      text: 'Reduction Factor',
      fieldName: 'reduction_rate_percentage',
      disabled: true,
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.reduction_rate_percentage),
      valueFn: r => r.data.object.reduction_rate_percentage != null ? `${Number(r.data.object.reduction_rate_percentage).toFixed(1)}%` : ''
    } : null, claim.is_staffing_cost_rate_reduction_required ? {
      text: 'Eligible Total',
      fieldName: 'eligible_total_amount',
      disabled: true,
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.eligible_total_amount),
      valueFn: r => r.data.object.eligible_total_amount ?? ''
    } : null, {
      text: 'Capitalised Costs (if any)',
      fieldName: 'capitalised_costs',
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.capitalised_costs),
      valueFn: r => r.data.object.capitalised_costs ?? ''
    }, {
      text: 'Direct R&D%',
      fieldName: 'direct_rnd_percentage',
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.direct_rnd_percentage),
      valueFn: r => r.data.object.direct_rnd_percentage != null ? `${Number(r.data.object.direct_rnd_percentage).toFixed(1)}%` : ''
    }, {
      text: 'Indirect R&D%',
      fieldName: 'indirect_rnd_percentage',
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.indirect_rnd_percentage),
      valueFn: r => r.data.object.indirect_rnd_percentage != null ? `${Number(r.data.object.indirect_rnd_percentage).toFixed(1)}%` : ''
    }, {
      text: 'Consolidated % of Time Spent',
      fieldName: 'consolidated_percentage_of_time_spent',
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.consolidated_percentage_of_time_spent),
      valueFn: r => r.data.object.consolidated_percentage_of_time_spent != null ? `${Number(r.data.object.consolidated_percentage_of_time_spent).toFixed(1)}%` : ''
    }, {
      text: 'Eligible R&D %',
      fieldName: 'eligible_rnd_percentage',
      cellType: 'percentage',
      decimalScale: 1,
      disabled: true,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.eligible_rnd_percentage),
      valueFn: r => r.data.object.eligible_rnd_percentage != null ? `${Number(r.data.object.eligible_rnd_percentage).toFixed(1)}%` : ''
    }, {
      text: 'R&D Amount',
      fieldName: 'rnd_amount',
      disabled: true,
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.rnd_amount),
      valueFn: r => r.data.object.rnd_amount ?? ''
    }, {
      text: 'P&L R&D Expenditure',
      fieldName: 'pnl_expenditure',
      disabled: true,
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.pnl_expenditure),
      valueFn: r => r.data.object.pnl_expenditure ?? ''
    }, {
      text: 's1308 Claim',
      fieldName: 's1308_claim',
      disabled: true,
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.s1308_claim),
      valueFn: r => r.data.object.s1308_claim ?? ''
    }].filter(Boolean)
  }
};
export const staffingCostFragmentTableSettings = {
  headers
};